import { ScalpingStore } from './scalping.types';

// ===== To be used with Reactive Selectors only =====
// #region Reactive Data Selectors
const selectLatestCommissionRebate = (store: ScalpingStore) =>
  store.state.latestCommissionRebate;
const selectTotalCommissionRebate = (store: ScalpingStore) =>
  store.state.totalCommissionRebate;

const resetScalpingStore = (store: ScalpingStore) => store.actions.resetScalpingStore;
const updateScalpingStore = (store: ScalpingStore) =>
  store.actions.updateScalpingRebateAmount;

// #endregion Reactive Data Selectors

export {
  selectLatestCommissionRebate,
  selectTotalCommissionRebate,
  resetScalpingStore,
  updateScalpingStore,
};
